import {AddressServiceName, ToastNotificationServiceName} from "../../../../utils/names/serviceNames";
import {Address} from "../../../model/Address";
import {INgModelController, IScope} from "angular";
import {AddressService} from "../../../service/address.service";
import {ToastNotificationService} from "../../../../utils/ToastNotificationService";

interface AddressControlSubmitControllerScopeParent extends IScope {
    addressForm: INgModelController;
}

interface AddressControlSubmitControllerScopeTranscludedParent extends IScope {
    $parent: AddressControlSubmitControllerScopeParent;
}

interface AddressControlSubmitControllerScope extends IScope {
    $parent: AddressControlSubmitControllerScopeTranscludedParent;
}

export class AddressControlSubmitController {
    static instance = {
        template: require('./address-control-submit.html'),
        controller: ['$scope',
            AddressServiceName,
            ToastNotificationServiceName,
            AddressControlSubmitController],
        bindings: {
            address: '=',
            onSubmit: '<',
        }
    };

    constructor(private $scope: AddressControlSubmitControllerScope,
                private addressService: AddressService,
                private toastNotificationService: ToastNotificationService) {
    }

    $onInit = () => {
        //todo any idea of cleaner implementation?
        this.form = this.$scope.$parent.$parent.addressForm;
    };

    private address: Address;
    private onSubmit?: any;
    private form: INgModelController;

    submit = () => this.addressService.verifyAddress(this.address)
        .then(
            (resp) => {
                let verifiedAddress = resp.data;
                if (verifiedAddress.verification.valid) {
                    this.onSubmit(verifiedAddress);
                } else {
                    this.toastNotificationService.generateWarningMessage(verifiedAddress.verification.message);
                }
            }
        );

    submitDisabled() {
        return this.form.$invalid;
    }
}